import { useSelector } from 'react-redux'
import { selectedDealership } from '../../../../store/selectors/dealershipSelector'
import { useMutation, useQuery } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const useVerifyFTPUploadFile = () => {
  const dealership = useDealership()

  return useMutation(({ data }: { data: any }) =>
    fetch(
      `${import.meta.env.VITE_API_URL}/agencies/${
        dealership?.organization_id
      }/dealership/${dealership?.id}/customers/ftp/verify_ftp_file`,
      {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          'X-Org-Id': String(dealership?.organization_id),
        },
        credentials: 'include',
      },
    )
      .then((res) => res.json())
      .then((response: any) => {
        return response
      }),
  )
}
